/* 100MG — global.js */
(function () {
  'use strict';

  /* ----------------------------------------------------------------
     Menu drawer
  ---------------------------------------------------------------- */
  var drawer = document.querySelector('[data-menu-drawer]');
  var header = document.querySelector('[data-site-header]');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (header) header.classList.toggle('menu-open', open);
    var toggle = document.querySelector('[data-menu-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) {
      setDrawer(!drawer.classList.contains('is-open'));
    }
    if (e.target.closest('[data-menu-close]') || e.target.matches('.menu-drawer__overlay')) {
      setDrawer(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  /* ----------------------------------------------------------------
     Transparent header on hero pages
  ---------------------------------------------------------------- */
  if (header && header.classList.contains('site-header--transparent')) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----------------------------------------------------------------
     Collection tabs
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-collection-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = root.querySelector('[data-panel="' + tab.dataset.tab + '"]');
        if (panel) {
          panel.classList.add('is-active');
          updateArrows(panel.querySelector('[data-carousel]'));
        }
      });
    });
  });

  /* ----------------------------------------------------------------
     Carousels
  ---------------------------------------------------------------- */
  function updateArrows(carousel) {
    if (!carousel) return;
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.toggleAttribute('disabled', track.scrollLeft <= 2);
    next.toggleAttribute('disabled', track.scrollLeft >= max);
  }

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    if (!track) return;
    var step = function () {
      var item = track.querySelector(':scope > *');
      return item ? item.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    };
    carousel.addEventListener('click', function (e) {
      if (e.target.closest('[data-carousel-prev]')) track.scrollBy({ left: -step(), behavior: 'smooth' });
      if (e.target.closest('[data-carousel-next]')) track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () { updateArrows(carousel); }, { passive: true });
    window.addEventListener('resize', function () { updateArrows(carousel); });
    updateArrows(carousel);
  });

  /* ----------------------------------------------------------------
     Scroll reveal
  ---------------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { observer.observe(el); });
  }

  /* ----------------------------------------------------------------
     Product form — variant selection
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants-json]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var priceEls = document.querySelectorAll('[data-product-price]');
    var button = form.querySelector('[data-add-to-cart]');

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.dataset.optionIndex, 10)] = checked.value;
      });
      return opts;
    }

    function onChange() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (match) {
        idInput.value = match.id;
        if (match.price_formatted) {
          priceEls.forEach(function (el) { el.textContent = match.price_formatted; });
        }
        if (button) {
          button.disabled = !match.available;
          button.textContent = match.available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
        }
      }
    }

    form.addEventListener('change', onChange);
    onChange();
  });

  /* ----------------------------------------------------------------
     Cart drawer (AJAX cart)
  ---------------------------------------------------------------- */
  var drawerEl = document.getElementById('CartDrawer');

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = window.MONEY_FORMAT || '${{amount}}';
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/<[^>]*>/g, '');
  }

  function setCartOpen(open) {
    if (!drawerEl) return;
    drawerEl.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function updateCount(cart) {
    var text = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    document.querySelectorAll('[data-cart-count], [data-cart-count-inline]').forEach(function (el) {
      el.textContent = text;
    });
  }

  function renderDrawer(cart) {
    if (!drawerEl) return;
    var lines = drawerEl.querySelector('[data-cart-lines]');
    var foot = drawerEl.querySelector('[data-cart-foot]');
    updateCount(cart);

    if (!cart.items.length) {
      lines.innerHTML = '<div class="cart-drawer__empty">Your cart is empty</div>';
      foot.hidden = true;
      return;
    }

    lines.innerHTML = cart.items.map(function (item, i) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') + '" alt="">'
        : '<span></span>';
      var meta = item.variant_title ? '<div class="meta">' + item.variant_title + '</div>' : '';
      return '<div class="cart-drawer__line">' +
        img +
        '<div><h4>' + item.product_title + '</h4>' + meta +
        '<div><span class="cart-drawer__qty">' +
        '<button type="button" data-line-qty="' + (i + 1) + '" data-delta="-1" aria-label="Decrease">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-line-qty="' + (i + 1) + '" data-delta="1" aria-label="Increase">+</button>' +
        '</span>' +
        '<button type="button" class="rm" data-line-remove="' + (i + 1) + '">Remove</button></div></div>' +
        '<div class="price">' + money(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    drawerEl.querySelector('[data-cart-subtotal]').textContent = money(cart.items_subtotal_price);
    foot.hidden = false;
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); return cart; });
  }

  function cartAdd(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    });
  }

  function cartChangeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderDrawer);
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      refreshCart().then(function () { setCartOpen(true); });
      return;
    }
    if (e.target.closest('[data-cart-close]')) { setCartOpen(false); return; }
    if (e.target.closest('[data-cart-checkout]')) { window.location.href = '/checkout'; return; }

    var qty = e.target.closest('[data-line-qty]');
    if (qty) {
      var current = parseInt(qty.parentElement.querySelector('span').textContent, 10);
      cartChangeLine(parseInt(qty.dataset.lineQty, 10), Math.max(0, current + parseInt(qty.dataset.delta, 10)));
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { cartChangeLine(parseInt(rm.dataset.lineRemove, 10), 0); return; }
  });

  /* PDP add-to-cart goes through the drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !drawerEl) return;
    e.preventDefault();
    var button = form.querySelector('[data-add-to-cart]');
    var id = form.querySelector('[data-variant-id]').value;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    cartAdd({ id: parseInt(id, 10), quantity: 1 })
      .then(refreshCart)
      .then(function () { setCartOpen(true); })
      .catch(function (err) { alert(err.message); })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = button.dataset.labelAdd || 'Add to cart'; }
      });
  });

  /* ----------------------------------------------------------------
     Quick add (product cards)
  ---------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-quick-open]');
    if (open) {
      e.preventDefault();
      var wrap = open.closest('.quick-add');
      var pills = wrap.querySelector('.quick-add__pills');
      var show = pills.hidden;
      document.querySelectorAll('.quick-add__pills').forEach(function (p) { p.hidden = true; });
      document.querySelectorAll('.quick-add').forEach(function (q) { q.classList.remove('is-open'); });
      pills.hidden = !show;
      wrap.classList.toggle('is-open', show);
      open.setAttribute('aria-expanded', show ? 'true' : 'false');
      return;
    }

    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      cartAdd({ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 })
        .then(refreshCart)
        .then(function () {
          setCartOpen(true);
          document.querySelectorAll('.quick-add__pills').forEach(function (p) { p.hidden = true; });
          document.querySelectorAll('.quick-add').forEach(function (q) { q.classList.remove('is-open'); });
        })
        .catch(function (err) { alert(err.message); })
        .finally(function () { quick.disabled = false; });
      return;
    }

    if (!e.target.closest('.quick-add')) {
      document.querySelectorAll('.quick-add__pills').forEach(function (p) { p.hidden = true; });
      document.querySelectorAll('.quick-add').forEach(function (q) { q.classList.remove('is-open'); });
    }
  });

  /* ----------------------------------------------------------------
     PDP: sticky buy bar + image zoom
  ---------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sticky-add]')) {
      var mainBtn = document.querySelector('[data-product-form] [data-add-to-cart]');
      if (mainBtn && !mainBtn.disabled) mainBtn.click();
    }
  });

  var gallery = document.querySelector('[data-pdp-gallery]');
  if (gallery && matchMedia('(min-width: 990px)').matches) {
    gallery.addEventListener('click', function (e) {
      var img = e.target.closest('img');
      if (!img) return;
      img.classList.toggle('is-zoomed');
    });
    gallery.addEventListener('mousemove', function (e) {
      var img = e.target.closest('img.is-zoomed');
      if (!img) return;
      var rect = img.getBoundingClientRect();
      img.style.transformOrigin =
        ((e.clientX - rect.left) / rect.width * 100) + '% ' +
        ((e.clientY - rect.top) / rect.height * 100) + '%';
    });
  }

  /* ----------------------------------------------------------------
     Cart quantity steppers
  ---------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var value = Math.max(0, parseInt(input.value || '0', 10) + parseInt(btn.dataset.qtyChange, 10));
    input.value = value;
    if (input.form) input.form.submit();
  });
})();
